import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { ContentBlock } from 'components/ContentBlock'
import { Form, Text } from 'components/forms'

const Tara = ({ formData, onUpdate }) => {
	const [t] = useTranslation()
	const getInputs = (start, end) => {
		const out = []
		for(let i = start; i <= end; i++) {
			out.push(<Text key={i} field={`taraName[${i}]`} placeholder={`Tara ${i + 1} eintragen`} />)
		}
		return out
	}
	return(
		<ContentBlock label={t('options_section.sub_sections.scales')}>
			<Form initialValues={formData} onSubmit={onUpdate} smartSubmit>
				<Row>
					<Col xs>
						<p className='form-group-label'>{t('options_section.fields.tare_name', { value: '1 - 10' })}</p>
						{getInputs(0, 9)}
					</Col>
					<Col xs>
						<p className='form-group-label'>{t('options_section.fields.tare_name', { value: '11 - 20' })}</p>
						{getInputs(10, 19)}
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default Tara
